import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import './style.less';

const stabTypeaheadIcon = '<svg id="stab-typeahead__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path stroke="none" d="M7.736.102C6.328.17 5.128.74 4.125 1.817c-1.31 1.408-1.733 3.44-1.1 5.28.132.38.12.36 1.05 2.054l2.865 5.213.913 1.5c.126.068.245.05.366-.053.1-.087-.007.1 1.313-2.302L12.25 8.57c.47-.85.69-1.32.796-1.7.584-2.068-.023-4.117-1.633-5.507C10.374.465 9.12.035 7.736.102m.66 3.333c1.567.267 2.153 2.274.987 3.38-.816.768-2.163.7-2.862-.143a1.98 1.98 0 0 1 1.874-3.237" fill="currentColor" fill-rule="evenodd"/></svg>';
const StabTypeaheadIcon = () => (
    <SVGIcon markup={stabTypeaheadIcon} className={'stab-typeahead__icon'} />
);

export default StabTypeaheadIcon;